import { motion } from "framer-motion";

const STATS = [
    { value: "6", label: "Drops / Year" },
    { value: "0", label: "Compromises" },
    { value: "100%", label: "Built To Last" },
    { value: "∞", label: "Energy Returned" },
];

export default function Manifesto() {
    return (
        <section
            id="story"
            data-testid="manifesto-section"
            className="relative bg-black py-24 lg:py-40 border-t border-white/10 grain overflow-hidden"
        >
            {/* Massive faded section number */}
            <p
                aria-hidden
                className="absolute -bottom-20 left-4 lg:left-12 font-display text-[14rem] lg:text-[22rem] leading-none text-outline opacity-[0.12] select-none pointer-events-none tabular-nums"
            >
                05
            </p>

            <div
                className="absolute inset-0 opacity-[0.05] pointer-events-none"
                style={{
                    backgroundImage:
                        "url(https://images.unsplash.com/photo-1605602922835-a08452b4179d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            />

            <div className="relative max-w-[1600px] mx-auto px-6 lg:px-12">
                <div className="grid grid-cols-12 gap-6">
                    <div className="col-span-12 md:col-span-3">
                        <p className="label-mono">— 05 / The Story</p>
                    </div>
                    <div className="col-span-12 md:col-span-9">
                        <motion.h2
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.9 }}
                            className="font-display text-3xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
                        >
                            We design for the ones who arrive without announcement.{" "}
                            <span className="italic text-muted-foreground">
                                For movement that doesn't ask permission.
                            </span>{" "}
                            For energy that you bring, not the kind you borrow.
                            <br />
                            <br />
                            Every cut is intentional. Every detail earned. Built
                            heavy. Worn light.{" "}
                            <span className="text-outline italic">
                                Made to last as long as you do.
                            </span>
                        </motion.h2>
                    </div>
                </div>

                <div className="mt-24 grid grid-cols-2 md:grid-cols-4 gap-6">
                    {STATS.map((s, i) => (
                        <motion.div
                            key={s.label}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: i * 0.1 }}
                            className="border-t border-white/15 pt-6 relative"
                            data-testid={`stat-${i}`}
                        >
                            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground absolute -top-3 right-0 bg-black px-2">
                                0{i + 1}
                            </p>
                            <p className="font-display text-5xl md:text-7xl tracking-tighter">
                                {s.value}
                            </p>
                            <p className="label-mono mt-2">{s.label}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
